import { render, staticRenderFns } from "./screen-list.vue?vue&type=template&id=0287622c&"
import script from "./screen-list.vue?vue&type=script&lang=js&"
export * from "./screen-list.vue?vue&type=script&lang=js&"
import style0 from "./screen-list.vue?vue&type=style&index=0&id=0287622c&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports